export default "__VITE_ASSET__DeOvgjQ6__"